function ServiceMetrics({ items }) {
  return (
    <section className="service-section service-metrics-section" aria-label="Business snapshot">
      <div className="container service-metrics">
        {items.map((item) => (
          <div className="service-metric" key={item}>
            <span>{item}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ServiceMetrics;
